import React from "react";
import styled from "styled-components";
import { IconButton } from "styled_components/Common/IconButton";
const CDN_URL = process.env.REACT_APP_CDN_URL;
const LeftArrow = `${CDN_URL}common/down-arrow-hover.svg`;

const ComponentStyle = styled.div`
  width: 100%;
  height: 100%;
  position: relative;
  background: ${(props) => props.theme.componentBackground};
  color: ${(props) => props.theme.defaultFontColor};
  #icon-button-back {
    position: absolute;
    top: -2vw;
    left: -3vw;
    transform: rotate(90deg);
    img {
      width: 20px;
      height: 20px;
      margin-bottom: 10px;
    }
  }
  .box-wrapper {
    display: flex;
    height: 50%;
  }
  .box {
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    &.top {
      border-bottom: 1px solid #cfd2d3;
    }
    &.left {
      border-right: 1px solid #cfd2d3;
    }
    &.right {
      border-left: 1px solid #cfd2d3;
    }
  }

  @media screen and (min-width: ${(props) =>
      props.theme.res.medium}) and (max-width: ${(props) =>
      props.theme.res.high}) {
  }
  @media screen and (min-width: ${(props) => props.theme.res.high}) {
  }
`;

export const BillingDetails = ({ goToInvoiceHistory, invoice }) => {
  return (
    <ComponentStyle>
      <IconButton
        enabled={true}
        id="icon-button-back"
        module={"billing"}
        onClick={goToInvoiceHistory}
        style={{ cursor: "pointer" }}
      >
        <img src={LeftArrow} alt="arrow-icon" onClick={goToInvoiceHistory} />
      </IconButton>
      <div className="box-wrapper">
        <div className="box top left">
          <div className="body10">{invoice?.status}</div>
          <div className="labels21">Status</div>
        </div>
        <div className="box top right">
          <div className="body10">{invoice?.dueDate}</div>
          <div className="labels21">Due</div>
        </div>
      </div>
      <div className="box-wrapper">
        <div className="box left">
          <div className="body10">{invoice?.amount_due}</div>
          <div className="labels21">Total </div>
        </div>
        <div className="box right ">
          <div className="body10">{invoice?.amount}</div>
          <div className="labels21">Balance </div>
        </div>
      </div>
    </ComponentStyle>
  );
};
